import { StyledImageWrapper } from 'modules/campaigns/lib/components/CampaignPreviewThumbnail';
import { CHECKBOX_STATUS, Checkbox } from 'ui/checkbox';
import { GridRow } from 'ui/indexPages/tables/grid';
import { Skeleton } from 'ui/skeleton';
import { CAMPAIGN_GRIDS } from '../constants';

type Props = {
  numRows?: number | null;
};

export const SkeletonRows = ({ numRows = 10 }: Props) => (
  <>
    {Array(numRows)
      .fill(null)
      .map((_, i) => (
        <GridRow gridLayout={CAMPAIGN_GRIDS} data-test="skeleton-row" key={i}>
          <Checkbox data-test="row-checkbox" status={CHECKBOX_STATUS.UNCHECKED} />
          <div data-test="campaign-thumbnail-skeleton-cell">
            <StyledImageWrapper>
              <Skeleton />
            </StyledImageWrapper>
          </div>
          {Array(5)
            .fill({})
            .map((a, b) => (
              <div key={b}>
                <Skeleton data-test="campaign-skeleton-cell" />
              </div>
            ))}
        </GridRow>
      ))}
  </>
);
